import {
    Unstable_Grid2 as Grid,  Box, 
    Step,
    StepLabel,
    Stepper} from '@mui/material';
import {   OutputTableInfo, TableDataOutput } from '../../../data/interfaces/sharedmodels';
import {  useAppSelector } from '../../../stores/hooks';
import OutputTables from '../../../shared/tablegencomponenents/outputtables';
import { useState, useEffect } from 'react';
import itsoService from '../../../data/api/itso.service';
import NLCList from '../../../shared/nlclist';
import BuildSettings from '../../../shared/tablegencomponenents/buildsettings';
import BuildSummary from '../../../shared/tablegencomponenents/buildsummary';
import OutputTableDetails from '../../../shared/tablegencomponenents/outputtabledetails';





export default function ItsoOutputTables() {

    const selectedTable = useAppSelector((state) => state.itsoReducer.selectedOutputTable);
    
    const [tables, setTables] = useState<OutputTableInfo[]>([]);
    const [widthArray, setWidthArray] = useState([3, 3, 6]);
    const tableexpanded = useAppSelector((state) => state.itsoReducer.outputtableExpanded);
    const activeStep = useAppSelector((state) => state.itsoReducer.buildTableStep);
    useEffect(() => {
        itsoService.getoutputTables().then((response) => {
            setTables(response.data);
        })
    }, []);

    

    useEffect(() => {
        if (tableexpanded) {
            setWidthArray([0, 0, 12]);

        }
        else {
            setWidthArray([3, 3, 6]);
        }
    }, [tableexpanded]);
    return (
        <Box>
            <Stepper activeStep={activeStep} sx={{p:1,pb:2}}>
                <Step>
                    <StepLabel>Select Tables & Stations</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Confim Settings</StepLabel>
                </Step>
                <Step>
                    <StepLabel>Summary</StepLabel>
                </Step>
                
            </Stepper>
            {activeStep==0?
                <Grid container spacing={tableexpanded ? 0 : 1}>
                    <Grid xs={widthArray[0]}>
                        <OutputTables parent='itso' tables={tables} />
                    </Grid>
                    <Grid xs={widthArray[1]}>
                        <NLCList parent='itso_output' disabled={selectedTable == null ? false : selectedTable.IsGlobal} />
                    </Grid>
                    <Grid xs={widthArray[2]}>
                    <OutputTableDetails table={selectedTable} parent='magnetic'/>
                    </Grid>
                </Grid>
                :activeStep==1?
                <BuildSettings parent='itso'></BuildSettings>
                :<BuildSummary parent='itso'/>}
        </Box>
    );
}